import { useContext } from 'react'

import { FollowUpOtbContext } from '@provider/Otb/FollowUpProvider'

import { IFollowUpOtbContext } from '@base/@types/providers/Otb/FollowUpProvider'

export default function useOtbFollowUp(): IFollowUpOtbContext {
  const context = useContext(FollowUpOtbContext)

  return context
}
